import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatMenuModule } from "@angular/material/menu";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBarModule } from "@angular/material/snack-bar";

import { OdontogramaChartComponent } from "./odontograma-chart/odontograma-chart.component";
import { CaraPopoverComponent } from "./cara-popover/cara-popover.component";
import { CrearOdontogramaComponent } from "./crear-odontograma/crear-odontograma.component";
import { OdontogramaDetalleComponent } from "./odontograma-detalle/odontograma-detalle.component";
import { MatTabsModule } from "@angular/material/tabs";
import { PerioPopoverComponent } from "../periodontograma/perio-popover/perio-popover.component";
import { PeriodontogramaChartComponent } from "../periodontograma/periodontograma-chart/periodontograma-chart.component";
import { PeriodontogramaDetalleComponent } from "../periodontograma/periodontograma-detalle/periodontograma-detalle.component";
import { PerioBandaComponent } from "../periodontograma/perio-banda/perio-banda.component";
import { CrearPeriodontogramaComponent } from "../periodontograma/crear-periodontograma/crear-periodontograma.component";

@NgModule({
  declarations: [
    OdontogramaChartComponent,
    CaraPopoverComponent,
    CrearOdontogramaComponent,
    OdontogramaDetalleComponent,
    PerioPopoverComponent,
    PeriodontogramaChartComponent,
    PeriodontogramaDetalleComponent,
    PerioBandaComponent,
    CrearPeriodontogramaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatSnackBarModule,
    MatTabsModule,
  ],
  exports: [
    OdontogramaChartComponent,
    CrearOdontogramaComponent,
    OdontogramaDetalleComponent,
    PeriodontogramaChartComponent,
    PeriodontogramaDetalleComponent,
    CrearPeriodontogramaComponent,
  ],
})
export class OdontogramaSharedModule {}
